import { render, staticRenderFns } from "./threejs13.vue?vue&type=template&id=2be07d40&scoped=true"
import script from "./threejs13.vue?vue&type=script&lang=js"
export * from "./threejs13.vue?vue&type=script&lang=js"
import style0 from "./threejs13.vue?vue&type=style&index=0&id=2be07d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be07d40",
  null
  
)

export default component.exports